import { Component, Inject, OnInit } from '@angular/core';
import { SopoDialogRef, SOPO_DIALOG_DATA } from '../../interfaces/dialog';
import { FormControl, Validators } from '@angular/forms';

export interface SopoStringInputData {
    header?: string;
    body?: string;
    okText?: string;
    cancelText?: string;
    placeholder?: string;
    inputType?: string;
    maxLength?: number;
    numberOnly?: boolean;
    cancelReturn?: boolean;
    email?: boolean;
    prefilledString?: string;
    forNickName?: boolean;
    noPattern?: boolean;
}

@Component({
    selector: 'app-sopo-string-input',
    templateUrl: './sopo-string-input.component.html',
    styleUrls: ['./sopo-string-input.component.scss'],
    standalone: false
})
export class SopoStringInputComponent implements OnInit {
    private numberOnly: boolean = false;
    private cancelReturn: boolean = false;
    header: string = '';
    body: string = '';
    placeholder: string = 'Type here...';
    okText: string = 'Ok';
    cancelText: string = '';
    inputType: string = 'text'
    maxlength: number = 100;
    email: boolean = false;
    autocomplete = "off";
    forNickName: boolean = false;
    noPattern: boolean = false;
    nickname_validations = [
        { type: 'required', message: 'Nickname is required.' },
        {
            type: 'pattern',
            message: 'Nickname should only contain English alphabetical characters.',
        },
    ];

    showEmailError: boolean = false;
    inputControl: FormControl;

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoStringInputData,
        private sopoDialogRef: SopoDialogRef,
    ) {
        if (data.header) this.header = data.header;
        if (data.body) this.body = data.body;
        if (data.placeholder) this.placeholder = data.placeholder;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText;
        if (data.inputType) this.inputType = data.inputType;
        if (data.maxLength) this.maxlength = data.maxLength;
        if (data.numberOnly) this.numberOnly = data.numberOnly
        if (data.cancelReturn) this.cancelReturn = data.cancelReturn;
        if (data.email) this.email = data.email;
        if (data.forNickName) this.forNickName = data.forNickName;
        if (data.noPattern) this.noPattern = data.noPattern;

        if (this.inputType === 'password') {
            this.autocomplete = "current-password";
        }

        this.inputControl = new FormControl(data.prefilledString ? data.prefilledString : '', [Validators.maxLength(this.maxlength)]);
        if (this.forNickName) this.inputControl.addValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')]);
    }

    ngOnInit() {}

    getPattern() {
        if (this.noPattern) {
            return '.*';
        } else if (this.email) {
            return '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
        } else if (this.numberOnly) {
            return '[0-9]*';
        } else if (this.forNickName) {
            return '^[a-zA-Z0-9 ]+$';
        } else {
            return '.*';
        }
    }

    close(close: boolean = false) {
        if (close) {
            if (this.cancelReturn && this.inputControl.value === undefined) {
                this.sopoDialogRef.close('');
            } else {
                this.sopoDialogRef.close(null);
            }
        } else {
            if (!this.inputControl.valid) return;
            this.sopoDialogRef.close(this.inputControl.value);
        }
    }

    validateInput(event: Event) {
        let value = (event.target as HTMLInputElement).value;
        if (value && value.length > this.maxlength) {
            value = value.slice(0, this.maxlength);
            this.inputControl.setValue(value, { emitEvent: false });
        }
        if (this.email) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            this.showEmailError = !emailPattern.test(this.inputControl.value);
        }
    }
}
